import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnnouncementService } from './announcement.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PlatformService, Platform } from 'aih-launchpad-core';
import { startWith, switchMap } from 'rxjs';
import { AnnouncementContent } from './announcement';

@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.sass'],
    standalone: true,
    imports: [
      TranslatePipe
    ]
})
export class AnnouncementComponent implements OnInit {
  announcements: AnnouncementContent[] = [];
  platform: Platform | undefined;

  constructor(
    private translate: TranslateService,
    private announcementService: AnnouncementService,
    private platformService: PlatformService) {
      this.translate.onLangChange
      .pipe(
        startWith({ lang: this.translate.currentLang }), // trigger on init too
        switchMap(({ lang }) => this.announcementService.getAnnouncements(lang)),
        takeUntilDestroyed()
      )
      .subscribe(data => {
        this.announcements = data;
      });
    }

  ngOnInit(): void {
    this.platform = this.platformService.platform;
  }
}
